import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";

export default function ValidationOptionsComponent({
  validationParams,
  formFieldValidationParams,
  setFormFieldValidationParams,
  selectedFormFieldParamsOptions,
}) {
  if (!validationParams) return null;

  return (
    <MDBox mt={2}>
      <MDBox p={1}>
        <MDTypography variant="h6" fontWeight="medium">
          Validation Options
        </MDTypography>
      </MDBox>

      {validationParams.length > 0 &&
        validationParams.map((record) => {
          let theValue = "";

          if (selectedFormFieldParamsOptions) {
            if (record.key in selectedFormFieldParamsOptions) {
              theValue = selectedFormFieldParamsOptions[record.key];
            }
          }

          if (record.options) {
            return (
              <MDBox mt={3} mb={2} key={record.key}>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>{record.name}</InputLabel>
                  <Select
                    label={record.name}
                    value={theValue || ""}
                    onChange={(e) => {
                      setFormFieldValidationParams((prev) => ({
                        ...(prev || {}),
                        [record.key]: e.target.value,
                      }));
                    }}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                  >
                    {record.options.length > 0 &&
                      record.options.map((opt) => (
                        <MenuItem key={opt.value} value={`${opt.value}`}>
                          {opt.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </MDBox>
            );
          }

          return (
            <MDBox mb={2} key={record.key}>
              <MDInput
                defaultValue={theValue}
                margin="dense"
                label={record.name}
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => {
                  if (!e.target.value) return;

                  setFormFieldValidationParams((prev) => ({
                    ...(prev || {}),
                    [record.key]: e.target.value,
                  }));
                }}
              />
            </MDBox>
          );
        })}
    </MDBox>
  );
}
